import { createRootRoute, Navigate, Outlet } from "@tanstack/react-router";
import { TooltipProvider } from "@timeghost/ui/shadcn/tooltip";
import type { JSX } from "react";
import ErrorPage from "@/components/pages/error-page";

const RootLayout = (): JSX.Element => (
	<TooltipProvider delay={280}>
		<main className="flex h-full min-h-0 flex-col overflow-hidden">
			<Outlet />
		</main>
	</TooltipProvider>
);

export const Route = createRootRoute({
	component: RootLayout,
	notFoundComponent: () => <Navigate to="/not-found" />,
	errorComponent: ({ error }) => <ErrorPage error={error} />,
});
